'use client';
export var RSUITE_PICKER_TYPE = Symbol.for('rsuite.picker');
export var RSUITE_PICKER_GROUP_KEY = Symbol.for('rsuite.picker_group_key');